<template>
    <div class="tasks">
        <div class="task_types">
            <div class="select-list">
                <span>Тип</span>
                <div class="select-list_drop">
                    <v-menu>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="white"
                                v-bind="attrs"
                                v-on="on"
                            >
                            <span>{{ testTypes.length > currentType ? testTypes[currentType] : '' }}</span>
                            <div class="drop-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41079 14.5118L3.57745 8.67851L4.75596 7.5L10 12.7441L15.2441 7.5L16.4226 8.67851L10.5893 14.5118C10.2639 14.8373 9.73622 14.8373 9.41079 14.5118Z" fill="black"/>
                                </svg>
                            </div>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                v-for="(item, index) in testTypes"
                                :key="index"
                                @change="changeType(index)"
                            >
                                <v-list-item-title>{{ item }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>
            <div class="tasks_search">
                <!-- <label for="search_name">Поиск по коду или названию</label> -->
                <input placeholder="Поиск" @input="search" />
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667C15.8333 10.7068 15.3111 12.125 14.4339 13.2538L17.6726 16.4941L16.4941 17.6726L13.2538 14.4339C12.125 15.3111 10.7068 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5ZM9.16667 4.16667C6.40524 4.16667 4.16667 6.40524 4.16667 9.16667C4.16667 11.9281 6.40524 14.1667 9.16667 14.1667C11.9281 14.1667 14.1667 11.9281 14.1667 9.16667C14.1667 6.40524 11.9281 4.16667 9.16667 4.16667Z" fill="#AAAEB7"/>
                </svg>
            </div>
        </div>
        <div class="tasks_header mb-8">
            <h1>{{ currentType === 0 ? 'Список тестов по системам организма' : 'Список тестов по диагностике пациента' }}</h1>
            <button v-if="editable" class="task_add ml-2" @click="addTask">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447715 4 1V4L1 4C0.447715 4 0 4.44771 0 5C0 5.55228 0.447715 6 1 6H4V9C4 9.55229 4.44772 10 5 10C5.55229 10 6 9.55229 6 9V6H9C9.55228 6 10 5.55228 10 5C10 4.44772 9.55229 4 9 4L6 4V1Z" fill="white"/>
                </svg>
                Добавить
            </button>
        </div>

        <v-tabs v-model="tab" align-with-title color="#4854FE">
            <v-tab class="ml-0" v-for="item in items" :key="'j'+item.id" @click="tabClick(item)">
                {{ item.name }}
            </v-tab>
        </v-tabs>

        <!-- <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item">
                <v-card flat>
                    <v-card-text>123</v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs-items> -->


        <v-data-table
            class="elevation-1 tasks_table"
            ref="taskTable"
            :headers="currentType === 1 ?  headers : headers1"
            :items="tasks"
            :sort-by.sync="params.sortOption.fieldName"
            :server-items-length="pagesCount"
            :items-per-page="params.pageSize"
            :page="params.currentPage"
            :loading="loadingTable"
            loading-text="Данные загружаются..."
            hide-default-footer
        >
            <template v-slot:[`item.studyDisciplineName`]="{ item }">
                {{ `${item.studyDisciplineName || '–'}` }}
            </template>

            <template v-slot:[`item.studyTopicName`]="{ item }">
                {{ `${item.studyTopicName || '–'}` }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                <div :class="{ 'actions': true, 'blocked': loading.id === item.id, 'enabled': loading.id === null }">
                    <v-btn
                        v-if="currentType === 1 && item.createStatusKey != 'Archived'"
                        @click="startDiagnostic(item)"
                        :disabled="loading.id !== null && !loading.show"
                        :loading="loading.show || loadStartDiagnostic"
                        class="task_look">
                        Пройти тест
                    </v-btn>
                    <v-btn
                        v-if="item.canEdit && editable && (item.createStatusKey === createStatuses.InProgress || item.createStatusKey === createStatuses.Done)"
                        @click="setCreateStatus(item, createStatuses.Published)"
                        :disabled="loading.id !== null && !loading.publish"
                        :loading="loading.publish"
                        class="task_look">
                        Опубликовать
                    </v-btn>
                    <v-btn
                        v-if="editable && item.createStatusKey === createStatuses.Published && item.canEdit"
                        @click="setCreateStatus(item, createStatuses.Done)"
                        :disabled="loading.id !== null && !loading.publish"
                        :loading="loading.publish"
                        class="task_look">
                        Снять с публикации
                    </v-btn>
                    <v-btn
                        @click="currentType === 0 ? showTask(item.id) : showCreateTest(item)"
                        :disabled="loading.id !== null && !loading.show"
                        :loading="loading.show"
                        class="task_look">
                        Посмотреть
                    </v-btn>
                    <v-btn
                        v-if="currentType === 0 && editable"
                        @click="downloadTask(item.id)"
                        :disabled="loading.id !== null && !loading.download"
                        :loading="loading.download"
                        class="task_look">
                        Скачать
                    </v-btn>
                    <v-btn
                        v-if="item.canEdit && editable && hideIfTraining || item.createStatusKey === 'Archived'"
                        @click="copyTask(item.id)"
                        :disabled="loading.id !== null && !loading.copy"
                        :loading="loading.copy"
                        class="task_look">
                        Копировать
                    </v-btn>
                    <v-btn
                        v-if="item.canEdit && editable && hideIfTraining && item.createStatusKey !== 'Archived'"
                        @click="editTask(item)"
                        :disabled="disabledEditable(item) || (loading.id !== null && !loading.edit)"
                        :loading="loading.edit"
                        class="task_look">
                        Редактировать
                    </v-btn>
                    <v-btn
                        v-if="item.canEdit && editable && item.createStatusKey !== 'Archived'"
                        @click="archiveTask(item.id)"
                        :disabled="item.createStatusKey === createStatuses.Published || (loading.id !== null && !loading.delete)"
                        :loading="loading.delete"
                        class="task_look">
                        Архивировать
                    </v-btn>
                </div>
            </template>

            <template v-slot:footer>
                <div class="data-footer">
                    <div class="pagination" v-if="params.pageSize != allItemsSize">
                        <span>Cтраница:</span>
                        <div class="pagination_prev" @click.prevent="prevPage">
                            <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path id="shape" fill-rule="evenodd" clip-rule="evenodd" d="M0.269108 8.64968L6.70064 15.0812L8 13.7818L2.21815 8L8 2.21815L6.70064 0.918787L0.269108 7.35031C-0.0897023 7.70912 -0.0897023 8.29087 0.269108 8.64968Z" fill="#878A91"/>
                            </svg>
                        </div>
                        <div class="pagination_number">
                            {{ params.currentPage + 1 }}
                        </div>
                        <div class="pagination_next" v-if="params.pageSize" @click.prevent="nextPage">
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.73089 8.64965L1.29936 15.0812L-5.6797e-08 13.7818L5.78185 7.99997L-5.62262e-07 2.21812L1.29936 0.918756L7.73089 7.35028C8.0897 7.70909 8.0897 8.29084 7.73089 8.64965Z" fill="#878A91"/>
                            </svg>
                        </div>
                    </div>
                    <div class="select-list">
                        <span>Выводить:</span>
                        <div class="select-list_drop">
                            <v-menu>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="white"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                    <span>{{ params.pageSize != allItemsSize ? params.pageSize : 'Все' }}</span>
                                    <div class="drop-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41079 14.5118L3.57745 8.67851L4.75596 7.5L10 12.7441L15.2441 7.5L16.4226 8.67851L10.5893 14.5118C10.2639 14.8373 9.73622 14.8373 9.41079 14.5118Z" fill="black"/>
                                        </svg>
                                    </div>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item
                                        v-for="(item, index) in pageSizes"
                                        :key="index"
                                        @change="updatePageSize(item.size)"
                                    >
                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </div>
                </div>
            </template>
        </v-data-table>

        <div v-show="taskDialog.show" class="result-shadow">
            <div class="result-wrap">
                <button class="result_close" @click.prevent="taskDialog.show = false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="result_body">
                    <h2>Тест “{{ taskDialog.task.title }}”</h2>
                    <div class="result_header">
                    <div class="result_header-img">
                        <BodySystemsSvg :id="taskDialog.task.bodySystemId"/>
                        <p>{{ taskDialog.task.bodySystemName }}</p>
                    </div>
                    <div class="result_header-txt">
                        <div class="result_header-line">
                            <p class="box-1">Дисциплина</p>
                            <p class="box-2">{{ `${taskDialog.task.studyDisciplineName || '–'}` }}</p>
                        </div>
                        <div class="result_header-line">
                            <p class="box-1">Тема</p>
                            <p class="box-2">{{ `${taskDialog.task.studyTopicName || '–'}` }}</p>
                        </div>
                    </div>
                    </div>
                    <h3>Вопросы</h3>
                    <div ref="dialogTaskQuestions" class="result_body-quests">
                        <ul v-for="(question, questionIndex) in taskDialog.task.questions" :key="`question_${questionIndex}`" class="result_body-item" >
                            {{ `${questionIndex + 1}. ${question.title}` }}

                            <TaskMediaFiles v-if="question.files.length > 0" :files="question.files" />

                            <template v-if="question.questionType === 0 || question.questionType === 1">
                                <li
                                    v-for="(answer, answerIndex) in question.answers"
                                    :key="`answer_${answerIndex}`"
                                    :class="{ 'correct_answer': answer.correct }"
                                >
                                    {{ answer.title }}
                                </li>
                            </template>

                            <template v-else-if="question.questionType === 2">
                                <li
                                    v-for="(term, termIndex) in question.terms"
                                    :key="`term_${termIndex}`"
                                >
                                    {{ term.title }} — <span class="correct_answer">{{ getTermAnswer(question.termAnswers, term.id) }}</span>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <ImportDialog
            ref="importDialog"
            v-if="editable"
            v-show="importDialog.show"
            @success="loadTasks(archived)"
            @snackbar="(x) => snackbar = x"
            @close="importDialog.show = false"
        />

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import debounce from 'lodash.debounce';
import ImportDialog from './ImportDialog.vue';
import TaskMediaFiles from '@/components/TaskMediaFiles.vue';
import BodySystemsSvg from '@/components/Svg/BodySystems.vue';
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import { mapActions, mapGetters } from 'vuex';
import { helpers } from '@/store/tests';
import './index.scss';

const AllItemsSize = 1000;

export default {
    name: 'tasks',
    components: { ImportDialog, TaskMediaFiles, BodySystemsSvg, TimeoutSnackbar },
    props: {
        editable: Boolean
    },
    data() {
      return {
        archived: false,
        tab: null,
        items: [{id: 0, name: 'Актуальные'}, {id: 1, name: 'Архивные'}],
        testTypes: helpers.testTypes,
        createStatuses: helpers.createStatuses,
        currentType: 0,
        loadStartDiagnostic: false,
        loadingTable: false,
        params: {
            filters: [],
            sortOption: {
                fieldName: 'title',
                sortType: 2
            },
            pageSize: 10,
            currentPage: 0,
            useANDoperator: false,
            columns: [],
            createStatus: null
        },
        headers: [
            { text: 'Вид', value: 'passTypeName', width: '5%', sortable: false },
            { text: 'Пациент', value: 'patientFio', width: '5%', sortable: false },
            { text: 'Название задания', value: 'title', width: '10%', sortable: false },
            { text: 'Заболевание', value: 'diagnoseName', width: '10%', sortable: false },
            { text: 'Дисциплина', value: 'studyDisciplineName', width: '10%', sortable: false },
            { text: 'Тема', value: 'studyTopicName', width: '10%', sortable: false },
            { text: '', value: 'actions', width: '35%', sortable: false }
        ],
        headers1: [
            { text: 'Вид', value: 'passTypeName', width: '5%', sortable: false },
            { text: 'Название задания', value: 'title', width: '20%', sortable: false },
            { text: 'Дисциплина', value: 'studyDisciplineName', width: '20%', sortable: false },
            { text: 'Тема', value: 'studyTopicName', width: '20%', sortable: false },
            { text: '', value: 'actions', width: '35%', sortable: false }
        ],
        tasks: [],
        pagesCount: 0,
        allItemsSize: AllItemsSize,
        pageSizes: [
            { name: '5', size: 5 },
            { name: '10', size: 10 },
            { name: '15', size: 15 },
            { name: 'Все', size: AllItemsSize }
        ],
        importDialog: {
            show: false
        },
        taskDialog: {
            show: false,
            task: {}
        },
        snackbar: {
            show: false,
            text: null,
            color: null,
            timeout: -1
        },
        loading: {
            id: null,
            publish: false,
            show: false,
            download: false,
            copy: false,
            edit: false,
            delete: false
        }
      }
    },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            user: 'user/userInfo',
            userRoles: 'login/userRoles'
        }),
        hideIfTraining() {
            return this.currentType === 0 ? false : true
        },
        isTeacher() {
            let roles = localStorage.getItem('roles') || '';

            return roles == 'Teacher'
        }
    },
    methods: {
        ...mapActions({
            getPatient: 'patient/getPatient'
        }),
        changeType(taskType) {
            this.currentType = taskType;
            localStorage.setItem('taskType', taskType);
            this.loadTasks(this.archived);
        },
        disabledEditable(item) {
            // item.createStatusKey === createStatuses.Published ||
            // (item.hasResults && (item.createStatusKey != 'InProgress' || item.createStatusKey === 'Done'))

            // Если статус опубликован
            if(item.createStatusKey === this.createStatuses.Published) return true;
            
            // Если есть результат
            if(item.hasResults) return true;
            
            // Если нет результата но статус 
            if(item.hasResults) return true;

            return false
        },
        getRoute() {
            return this.currentType === 0 ? 'TestTask' : 'DiaTest';
        },
        loadTasks(flag) {
            this.loadingTable = true;

            let route = this.getRoute();
            if(flag) this.params.createStatus = 'Archived'
            else this.params.createStatus = this.editable ? null : this.createStatuses.Published;

            this.$http.post(`${this.apiUrl}${route}/GetAll`, this.params)
                .then((result) => {
                    this.tasks = result.data.data;
                    this.pagesCount = this.params.pageSize ? Math.ceil(result.data.totalRecords / this.params.pageSize) : 1;
                    this.loadingTable = false;
                });
        },
        tabClick(item) {
            if(this.tab === item.id) {
                return;
            }
            this.archived = item.name === 'Архивные' ? true : false;
            this.params.currentPage = 0
            this.loadTasks(this.archived);
        },
        prevPage() {
            if (this.params.currentPage > 0) {
                this.params.currentPage--;
                this.loadTasks(this.archived);
            }
        },
        nextPage() {
            if (this.params.currentPage < (this.pagesCount - 1)) {
                this.params.currentPage++;
                this.loadTasks(this.archived);
            }
        },
        updatePageSize(size) {
            this.params.currentPage = 0;
            this.params.pageSize = size;
            this.loadTasks(this.archived);
        },
        search: debounce(function (event) {
            let text = event.target.value;

            if (text && text.length > 0) {
                this.params.filters = [
                    {
                        fieldName: 'title',
                        filterType: 2,
                        filterValueType: 1,
                        value1: text,
                        value2: '',
                        values: []
                    },
                    {
                        fieldName: 'studyDisciplineName',
                        filterType: 2,
                        filterValueType: 1,
                        value1: text,
                        value2: '',
                        values: []
                    },
                    {
                        fieldName: 'studyTopicName',
                        filterType: 2,
                        filterValueType: 1,
                        value1: text,
                        value2: '',
                        values: []
                    }
                ];
            } else {
                this.params.filters = [];
            }

            this.params.currentPage = 0;
            this.loadTasks(this.archived);
        }, 1000),
        addTask() {
            if (this.currentType === 1) {
                // Если это диагностика, перенаправляем на страницу создания теста
                const routeData = this.$router.resolve({ name: 'CreateDiagnosticTest', params: { id: 'new' }});
                window.open(routeData.href, '_blank');
            } else {
                this.snackbar = { show: false };
                this.importDialog.show = true;
                this.$refs.importDialog.reset();
            }
        },
        showCreateTest(item) {
            this.editTask(item, true);
        },
        startDiagnostic(item) {
            this.loadStartDiagnostic = true;
            this.$http.get(`${this.apiUrl}DiaTest/Get?id=${item.id}`)
                .then((result) => {
                    this.$http.post(`${this.apiUrl}DiaTestProcess/CreateDiaTestProcess?assignId=${item.id}&diaTestId=${item.id}&studentId=${this.user.id}`)
                        .then((res) => {
                            // console.log(this.userRoles);
                            // console.log(`/${this.userRoles === 'Metodist' ? 'lk' : 'teacher'}/dia-test/${res.data.id}?diaTestId=${item.id}&gender=${result.data.patient.gender}&age=${result.data.patient.episodes[0].ageValue}&login=${this.user.login}`);

                            this.$router.push(`/${this.userRoles === 'Metodist' ? 'lk' : 'teacher'}/dia-test/${res.data.id}?diaTestId=${item.id}&gender=${result.data.patient.gender}&age=${result.data.patient.episodes[0].ageValue}&login=${this.user.login}`);
                            this.loadStartDiagnostic = false;
                        })
                })

        },
        showTask(id) {
            this.snackbar = { show: false };

            this.loading.id = id;
            this.loading.show = true;

            let route = this.getRoute();

            this.$http.get(`${this.apiUrl}${route}/Get?id=${id}`)
                .then((result) => {
                    console.log();
                    this.taskDialog.show = true;
                    this.taskDialog.task = result.data;

                    this.$nextTick(() => {
                        this.$refs.dialogTaskQuestions.scrollTop = 0;
                    });

                    this.loading.id = null;
                    this.loading.show = false;
                });
        },
        downloadTask(id) {
            this.snackbar = { show: false };

            this.loading.id = id;
            this.loading.download = true;

            let route = this.getRoute();

            this.$http.get(`${this.apiUrl}${route}/Export?id=${id}`, { responseType: 'blob' })
                .then((response) => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([response.data]));

                    let fileName = decodeURI(response.headers['content-disposition'].split('filename*=')[1].split("''")[1]);
                    link.setAttribute('download', fileName);

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    this.loading.id = null;
                    this.loading.download = false;
                });
        },
        copyTask(id) {
            this.snackbar = { show: false };

            this.loading.id = id;
            this.loading.copy = true;

            this.$http.post(`${this.apiUrl}DiaTest/CopyTest?testId=${id}`)
                .then((response) => {

                    console.log(this.tab);
                    // Если открыта вкладка Актуальные
                    if(this.tab !== 1) this.tasks.unshift(response.data);

                    this.loading.id = null;
                    this.loading.copy = false;

                    this.snackbar = {
                        text: 'Тест скопирован',
                        color: 'success',
                        timeout: 5000,
                        show: true
                    };
                }, () => {
                    this.loading.id = null;
                    this.loading.copy = false;

                    this.snackbar = {
                        text: 'Произошла ошибка. Тест не был скопирован.',
                        color: 'error',
                        timeout: -1,
                        show: true
                    };
                });
        },
        editTask(item, view){
            this.$router.push(`/lk/test-tasks-diagnostic/${item.id}${view ? '?view=true' : ''}`);
        },
        getTermAnswer(termAnswers, termId) {
            let answer = termAnswers.find(x => x.testQuestionTermId == termId);

            if (answer === undefined) {
                return '';
            }

            return answer.title;
        },
        setCreateStatus(task, status) {
            this.snackbar = { show: false };

            let confirmMessage = status === this.createStatuses.Published ? 'Вы действительно хотите опубликовать этот тест?' :
                'Вы действительно хотите снять с публикации этот тест?';

            if (!confirm(confirmMessage)) {
                return;
            }

            this.loading.id = task.id;
            this.loading.publish = true;

            let route = this.getRoute();

            this.$http.post(`${this.apiUrl}${route}/SetCreateStatus?id=${task.id}&key=${status}`)
                .then((response) => {
                    this.loading.id = null;
                    this.loading.publish = false;

                    if (response.data.success) {
                        task.createStatusId = response.data.result.createStatusId;
                        task.createStatusName = response.data.result.createStatusName;
                        task.createStatusKey = response.data.result.createStatusKey;

                        this.snackbar = {
                            text: status === this.createStatuses.Published ? 'Тест опубликован' : 'Тест снят с публикации',
                            color: 'success',
                            timeout: 5000,
                            show: true
                        };
                    } else {
                        this.snackbar = {
                            text: response.data.userMessage,
                            color: 'error',
                            timeout: -1,
                            show: true
                        };
                    }
                }, () => {
                    this.loading.id = null;
                    this.loading.publish = false;

                    this.snackbar = {
                        text: status === this.createStatuses.Published ? 'Произошла ошибка. Тест не был опубликован.' :
                            'Произошла ошибка. Тест не был снят с публикации.',
                        color: 'error',
                        timeout: -1,
                        show: true
                    };
                });
        },
        archiveTask(id) {
            this.snackbar = { show: false };

            if (!confirm("Вы действительно хотите архивировать этот тест?")) {
                return;
            }

            this.loading.id = id;
            this.loading.delete = true;

            let route = this.getRoute();
            // let action = this.currentType === 0 ? 'Delete' : 'MarkTestAsDelete';

            this.$http.post(`${this.apiUrl}${route}/SetCreateStatus?id=${id}&key=Archived`)
                .then(() => {
                    this.tasks = this.tasks.filter(x => x.id !== id);

                    this.loading.id = null;
                    this.loading.delete = false;

                    this.snackbar = {
                        text: 'Тест архивирован',
                        color: 'success',
                        timeout: 5000,
                        show: true
                    };
                }, () => {
                    this.loading.id = null;
                    this.loading.delete = false;

                    this.snackbar = {
                        text: 'Произошла ошибка. Тест не был архивирован.',
                        color: 'error',
                        timeout: -1,
                        show: true
                    };
                });
        }
    },
    created() {
        if(this.isTeacher) {
            this.items = this.items.filter((f) => f.id !== 1);
        }

        if (this.editable && this.headers.length > 0 || this.headers1.length > 0 ) {
            this.headers.splice(this.headers.length - 1, 0, { text: 'Статус', value: 'createStatusName', width: '9%', sortable: false });
            this.headers1.splice(this.headers1.length - 1, 0, { text: 'Статус', value: 'createStatusName', width: '9%', sortable: false });
            this.headers[1].width = '17%';
            this.headers[2].width = '17%';
            this.headers[3].width = '17%';
            this.headers1[1].width = '17%';
            this.headers1[2].width = '17%';
            this.headers1[3].width = '17%';
        }

        this.currentType = Number(localStorage.getItem('taskType'));
        this.loadTasks(this.archived);
    }
}
</script>
